import { render, staticRenderFns } from "./EditContactClienteSolcitudInfo.vue?vue&type=template&id=4d88f438&scoped=true&"
import script from "./EditContactClienteSolcitudInfo.vue?vue&type=script&lang=js&"
export * from "./EditContactClienteSolcitudInfo.vue?vue&type=script&lang=js&"
import style0 from "./EditContactClienteSolcitudInfo.vue?vue&type=style&index=0&id=4d88f438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88f438",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
